var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confettis"},_vm._l((_vm.numberOfConfettis),function(repetition){return _c('Lottie',_vm._g({key:repetition,staticClass:"confetti",attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.options}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }